<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Population</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_population.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div echarts [options]="options" [merge]="data" class="chart" (chartInit)="onChartInit($event)"></div>
        </div>
        <p style="font-size: 10px;margin-top:0px; margin-bottom: 0px; text-align: right;">
            Source : INSEE
        </p>
    </div>
</div>
